import React from 'react'

import { Chart, Source, Ticker, YAxis } from 'types'
import AssetClass from 'types/assetClass'

import useQuarterlyListed from 'hooks/useQuarterlyListed'

import useCatalog from 'hooks/useCatalog'
import useDefaultSeries from 'hooks/useDefaultSeries'
import ChartWrapper from '../common/BsLangChartWrapper'

const OptionVolume: React.FC = () => {
  const title = 'Volume'
  const id = `${AssetClass.OPTION}-${title}`
  const listOfActiveExpires = useQuarterlyListed({
    exchange: Source.DERIBIT,
    currency: Ticker.BTC,
  })
  const sources = [Source.DERIBIT, Source.BYBIT]
  const { data: catalog, isLoading: catalogLoading } = useCatalog({
    assets: [AssetClass.OPTION],
    active: [true],
    sources,
    generateCurrencyPairs: false,
    listInstruments: true,
  })

  const defaults = useDefaultSeries({
    catalogLoading,
    items: listOfActiveExpires,
    assetClass: AssetClass.OPTION,
    path: 'volume.sum',
  })

  if (!catalogLoading && !catalog) {
    return <div>An Error occurred, please refresh.</div>
  }

  return (
    <ChartWrapper
      catalog={catalog}
      defaultSeries={defaults}
      id={id}
      title={title}
      axisDefault={{ [YAxis.LEFT]: 'n2' }}
      assetClass={AssetClass.OPTION}
      suffix="sum"
      seriesType="volume"
      sources={sources}
      defaultChartType={Chart.TIMESERIES_BAR}
      disableMinutes
      useInstrument
    />
  )
}

export default OptionVolume
